module.exports = __webpack_public_path__ + "static/kerryAward-eb45fed0b7768ace7dd527de9cd60e93.png";